// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qZTKQZoNmXtFdD4OBpYk{animation:O4Zk4PUa8IiorOjmCIwa 2s infinite linear}@keyframes O4Zk4PUa8IiorOjmCIwa{from{transform:rotate(360deg)}to{transform:rotate(0deg)}}`, "",{"version":3,"sources":["webpack://./src/components/atomics/Spinner/Spinner.module.scss"],"names":[],"mappings":"AAAA,sBACE,iDAAA,CAGF,gCACE,KACE,wBAAA,CAEF,GACE,sBAAA,CAAA","sourcesContent":[".spinner {\n  animation: rotation 2s infinite linear;\n}\n\n@keyframes rotation {\n  from {\n    transform: rotate(360deg);\n  }\n  to {\n    transform: rotate(0deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `qZTKQZoNmXtFdD4OBpYk`,
	"rotation": `O4Zk4PUa8IiorOjmCIwa`
};
export default ___CSS_LOADER_EXPORT___;
